import AlertComponent from './index.vue'
import { createVM } from './createVM.js'

export function createAlert (Vue) {
  return createVM(AlertComponent)
}
export function show ($vm, options = {}) {
  if (typeof options === 'object') {
    Object.assign($vm, options)
  } else if (typeof options === 'string') {
    $vm.content = options
  }
  if (!this.watcher) {
    this.watcher = $vm.$watch('eventName', val => {
      if (val !== 'on-show') {
        setTimeout(() => ($vm.show = false), 300)
      }
      const eventName = val.replace(/-(\w)/g, (_, c) => c ? c.toUpperCase() : '')
      options[eventName] && options[eventName]()
    })
  }
  $vm.show = true
}
export function hide ($vm) {
  $vm.show = false
}



// WEBPACK FOOTER //
// ./src/components/alert/utils.js